/* IP geographic location chip: flag + City, Region, Country (ISP on hover). */
export const GeoCell = ({ geo, ip, testId, compact = false }) => {
  if (!geo || !geo.label) return <span className="text-slate-300" data-testid={testId}>{ip ? "locating…" : "—"}</span>;
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap" data-testid={testId}
          title={[geo.label, geo.isp && `ISP: ${geo.isp}`, ip].filter(Boolean).join("\n")}>
      {geo.country_code && (
        <img src={`https://flagcdn.com/16x12/${geo.country_code}.png`} alt={geo.country_code} width={16} height={12} className="rounded-[2px]" />
      )}
      <span className={compact ? "text-[10px] text-slate-500" : "text-slate-700"}>{geo.label}</span>
    </span>
  );
};
